import { type IconName } from "@/components/ui/icon";
import { profileNavIconButtonClassName } from "@/features/candidate/components/profile/layout/profile-nav-icon-button";

/**
 * @deprecated Use the `<ProfileNavIconButton>` component from
 * `@/features/candidate/components/profile/layout/profile-nav-icon-button`
 * instead. This re-export is preserved for one release cycle to avoid a hard
 * break; a follow-up PR will remove it.
 */
export const PROFILE_NAV_ICON_BTN = profileNavIconButtonClassName;

export const PROFILE_SIDEBAR_WIDTH = 440;

/** Spotlight typewriter: 20% faster than baseline 200 cps */
export const SPOTLIGHT_CHARS_PER_SECOND = 240;

export { LOGO_DEV_TOKEN } from "@/lib/logo-dev";

export const EXPERIENCE_SUMMARY_MAX_CHARS = 300;

export type ProfileTab =
  | "profile"
  | "jobs"
  | "sequences"
  | "activities"
  | "resume"
  | "scorecards"
  | "conversations";

export interface ProfileTabDef {
  id: ProfileTab;
  label: string;
  icon: IconName;
}

export const TABS: ProfileTabDef[] = [
  { id: "profile", label: "Profile", icon: "IconPeopleCircle" },
  { id: "jobs", label: "Jobs", icon: "IconBag" },
  { id: "sequences", label: "Sequences", icon: "IconPaperPlane" },
  { id: "activities", label: "Activities", icon: "IconElectrocardiogram" },
];

export const RESUME_TAB: ProfileTabDef = {
  id: "resume",
  label: "Resume",
  icon: "IconFileBend",
};

export const SCORECARDS_TAB: ProfileTabDef = {
  id: "scorecards",
  label: "Scorecards",
  icon: "IconListSparkle",
};

export const MEETINGS_TAB: ProfileTabDef = {
  id: "conversations",
  label: "Meetings",
  icon: "IconVideo",
};
